import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { ITap, ITapVM } from 'app/models/tap';
import { IKeg } from 'app/models/keg';
import { ToastService } from 'app/services/toast.service';
import { IonicModule, ModalController } from '@ionic/angular';
import { SelectCustomKegMonComponent } from 'app/components/select-custom-keg-mon/select-custom-keg-mon.component';
import { ICustomKegMon, ICustomKegMonVM } from 'app/models/customKegMon';
import { KegChooserPage } from '../keg-chooser/keg-chooser.page';
import { ISoftUpdate } from 'app/models/softUpdate';
import { SelectKegtronComponent } from 'app/components/select-kegtron/select-kegtron.component';
import { IKegtron, IKegtronVM } from 'app/models/kegtron';
import { SelectPlaatoComponent } from 'app/components/select-plaato/select-plaato.component';
import { IPlaato, IPlaatoVM } from 'app/models/plaato';
import { KegDetailPage } from 'app/pages/keg/keg-detail/keg-detail.page';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as dateHelper from 'app/helpers/date.helpers';
import { IPlaato2, IPlaato2VM } from 'app/models/plaato2';
import { SelectPlaato2Component } from 'app/components/select-plaato2/select-plaato.component';
import { PlaatoContentModeService } from 'app/services/helpers/plaato-content-mode.service';
import { Store } from '@ngrx/store';
import * as fromCo2 from 'app/state/co2-bottle';


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule
]
})
export class FormComponent implements OnChanges {


  @Input() useWashing: boolean = false;
  @Input() uid!: string;
  @Input() item!: ITapVM;
  @Input() allKegs!: IKeg[];
  @Input() allTaps!: ITap[];
  @Input() allPlaato2s!: IPlaato2[];
  @Input() allKegtrons!: IKegtron[];
  @Input() allCustomKegMons!: ICustomKegMon[];

  @Output() softUpdateKeg = new EventEmitter<ISoftUpdate<IKeg>>();
  @Output() softUpdateTap = new EventEmitter<ISoftUpdate<ITap>>();

  dateHelper = dateHelper;
  cleanDate!: string | null;
  form: FormGroup;
  plaato!: IPlaato | undefined;
  plaato2!: IPlaato2 | undefined;
  kegtron!: IKegtron | undefined;
  customKegMon!: ICustomKegMon | undefined;

  private contentModeService = inject(PlaatoContentModeService);
  private store = inject(Store);
  private allCo2Bottles = this.store.selectSignal(fromCo2.selectAllItems);

  /** A plaato can only be connected to ONE device at a time. When it is put to use
   *  on a tap/keg, any CO2 bottle that still points to it must be detached —
   *  otherwise the bottle is left with a stale connection (and wrong data). */
  private detachPlaatoFromCo2Bottles(plaatoId: string) {
    for (const b of this.allCo2Bottles()) {
      if (b.plaato2Id === plaatoId) {
        this.store.dispatch(fromCo2.updateItem({ item: { ...b, plaato2Id: null } }));
      }
    }
  }

  constructor(
    // public dateHelper: DateHelper,
    private modalController: ModalController,
    private toastService: ToastService
  ) {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      dispTemp: new FormControl(''),

    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.item) {
      this.setCurrentPlaato2();
      this.setCurrentKegtron();
      this.setCurrentCustomKegMon();
    }


    if (!!changes['item']?.currentValue) {
      //#region Date convertions
      if (!!this.item.cleanDate) {
        this.cleanDate = this.dateHelper.getISOString(this.item.cleanDate as any);
      }
      //#endregion Date convertions

      this.patchFormFromItem(this.item);
    }
  }



  updateName() {
    if (this.form.controls['name'].invalid) {
      this.toastService.error("Name is required");
      return;
    }
    if (this.item.id && this.form.controls['name'].value !== this.item.name) {
      const update: Partial<ITap> = {
        name: this.form.controls['name'].value
      };
      this.softUpdateCurrentTap(this.item.id, update);
    }
  }

  updateDisplayPlaatoTemp() {
    if (this.item.id && this.form.controls['dispTemp'].value !== this.item.dispTemp) {
      const update: Partial<ITap> = {
        dispTemp: this.form.controls['dispTemp'].value
      };
      this.softUpdateCurrentTap(this.item.id, update);
    }
  }

  // save(inTap: ITap, inKeg: IKeg) {
  //   inTap = this.populateItemFromForm(inTap);
  //   this.update.emit({ inTap, inKeg });
  // }


  //#region Date Functions
  //#region Clean Date
  setDefaultCleanDate() {
    if (this.item.id) {
      const date = new Date();
      this.cleanDate = dateHelper.toISOString();
      const update: Partial<ITap> = {
        cleanDate: date
      };
      this.softUpdateCurrentTap(this.item.id, update);
    }
  }

  setCleanDate(event: any) {
    if (this.item.id) {
      const value = event.detail.value;
      if (value) {
        const update: Partial<ITap> = {
          cleanDate: new Date(value)
        };
        this.softUpdateCurrentTap(this.item.id, update);
      }
    }
  }

  deleteCleanDate() {
    if (this.item.id) {
      this.cleanDate = null;
      const update: Partial<ITap> = {
        cleanDate: null
      };
      this.softUpdateCurrentTap(this.item.id, update);
    }
  }
  //#region Clean Date
  //#endregion Date Functons



  async openKeg(item: IKeg) {
    const modal = await this.modalController.create({
      component: KegDetailPage,
      componentProps: {
        isModal: true,
        itemId: item.id
      }
    });
    return await modal.present();
  }




  public async openKegChooser(tap: ITap) {
    const modal = await this.modalController.create({
      component: KegChooserPage,
      componentProps: { tap },
    });

    modal.onDidDismiss().then(async (data) => {

      const newKegData = { ...data.data };
      if (newKegData == null || newKegData.keg == null) {
        return;
      }

      const newKeg = newKegData.keg as IKeg;
      if (tap.id) {
        // A plaato on this tap that was previously weighing CO2 must be set
        // back to beer mode BEFORE the keg is attached — pessimistic, like
        // openPlaato2Modal: if the hardware command fails, the keg is NOT
        // attached, so the scale never reports CO2 readings for a beer keg.
        if (tap.plaato2Id) {
          const plaato = this.allPlaato2s?.find(x => x.id === tap.plaato2Id);
          if (plaato?.contentMode === 'co2') {
            const ok = await this.contentModeService.setContentMode(tap.plaato2Id, 'beer', this.uid);
            if (!ok) return;
          }
          // One device at a time: a CO2 bottle that still points to the plaato
          // is detached now that the plaato is going to measure a keg.
          this.detachPlaatoFromCo2Bottles(tap.plaato2Id);
        }
        const updateTap: Partial<ITap> = {
          kegId: newKeg.id,
        };
        this.softUpdateTap.emit({ id: tap.id, data: updateTap, uid: this.uid });
      }
    });

    return await modal.present();
  }



  public async openCustomKegMonModal(tap: ITap) {
    const modal = await this.modalController.create({
      component: SelectCustomKegMonComponent,
    });

    modal.onDidDismiss().then(async (data) => {

      if (!data.data)
        return;

      const customKegMon = data.data.item as ICustomKegMonVM;

      if (customKegMon.tap?.id) {
        this.removeCustomKegMonFromTap(customKegMon.tap.id);
      }
      if (tap.id && customKegMon.id) {
        this.addCustomKegMonToTap(tap.id, customKegMon.id);
      }
    });

    return await modal.present();
  }

  public async openKegtronModal(tap: ITap) {
    const modal = await this.modalController.create({
      component: SelectKegtronComponent,
    });

    modal.onDidDismiss().then(async (data) => {
      if (!data.data)
        return;

      const kegtron = data.data.item as IKegtronVM;
      if (kegtron.tap?.id) {
        this.removeKegtronFromTap(kegtron.tap.id);
      }
      if (tap.id && kegtron.id) {
        this.addKegtronToTap(tap.id, kegtron.id);
      }
    });

    return await modal.present();
  }


  public async openPlaato2Modal(tap: ITap) {
    const modal = await this.modalController.create({
      component: SelectPlaato2Component,
    });

    modal.onDidDismiss().then(async (data) => {

      if (!data.data?.item)
        return;

      const plaato = data.data.item as IPlaato2VM;
      if (tap.id && plaato.id) {
        // A plaato on a tap measures beer — set beer mode on the device FIRST.
        // If it fails, we change no connections (avoids a mismatch between
        // hardware and Firestore).
        const ok = await this.contentModeService.setContentMode(plaato.id, 'beer', this.uid);
        if (!ok) return;

        if (plaato.tap?.id) {
          this.removePlaato2FromTap(plaato.tap.id);
        }
        // One device at a time: if the plaato was connected to a CO2 bottle, the
        // bottle is detached now that the plaato is moved to this tap.
        this.detachPlaatoFromCo2Bottles(plaato.id);
        this.addPlaato2ToTap(tap.id, plaato.id);
      }
    });

    return await modal.present();
  }



  public async openPlaatoModal(tap: ITap) {
    const modal = await this.modalController.create({
      component: SelectPlaatoComponent,
    });

    modal.onDidDismiss().then(async (data) => {

      if (!data.data?.item)
        return;

      const plaato = data.data.item as IPlaatoVM;
      if (plaato.tap?.id) {
        this.removePlaatoFromTap(plaato.tap.id);
      }
      if (tap.id && plaato.apiKey && plaato.id) {
        this.addPlaatoToTap(tap.id, plaato.id, plaato.apiKey);
      }
    });

    return await modal.present();
  }


  deleteKeg(tapId: string) {
    this.removeKegFromTap(tapId);
  }


  deletePlaato(tap: ITap) {
    if (tap.id)
      this.removePlaatoFromTap(tap.id);
  }

  deleteCustomKegMon(tap: ITap) {
    if (tap.id)
      this.removeCustomKegMonFromTap(tap.id);
  }


  private softUpdateCurrentTap(tapId: string, item: Partial<ITap>) {
    const update: ISoftUpdate<ITap> = {
      id: tapId,
      data: item,
      uid: this.uid
    };
    this.softUpdateTap.emit(update);

  }


  private setCurrentPlaato2() {
    if (this.item.plaato2Id && this.item.id) {
      if (!!this.allPlaato2s && this.allPlaato2s.length > 0) {
        this.plaato2 = this.allPlaato2s.find(x => x.id === this.item.plaato2Id);
        if (!this.plaato2) {
          this.removePlaato2FromTap(this.item.id);
        }
      } else {
        //this.removePlaato2FromTap(this.item.id)
      }
    } else {
      this.plaato2 = undefined;
    }
  }

  private setCurrentKegtron() {
    if (this.item.kegtronId && this.item.id) {
      if (!!this.allKegtrons && this.allKegtrons.length > 0) {
        this.kegtron = this.allKegtrons.find(x => x.id === this.item.kegtronId);
        if (!this.kegtron) {
          this.removeKegtronFromTap(this.item.id);
        }
      } else {
        //this.removeKegtronFromTap(this.item.id)
      }
    } else {
      this.kegtron = undefined;
    }
  }


  private setCurrentCustomKegMon() {
    if (this.item.customKegMonId && this.item.id) {
      if (!!this.allCustomKegMons) {
        this.customKegMon = this.allCustomKegMons.find(x => x.id === this.item.customKegMonId);
        if (!this.customKegMon) {
          this.removeCustomKegMonFromTap(this.item.id);
        }
      } else {
        //this.removeCustomKegMonFromTap(this.item.id)
      }
    } else {
      this.customKegMon = undefined;
    }
  }


  private addCustomKegMonToTap(tapId: string, customKegMonId: string) {
    const updateTap: Partial<ITap> = {
      kegtronId: '',
      customKegMonId: customKegMonId,
      plaatoId: '',
      plaato2Id: '',
    };
    this.softUpdateCurrentTap(tapId, updateTap);
  }

  private addKegtronToTap(tapId: string, kegtronId: string) {
    const updateTap: Partial<ITap> = {
      kegtronId: kegtronId,
      customKegMonId: '',
      plaatoId: '',
      plaato2Id: '',
    };
    this.softUpdateCurrentTap(tapId, updateTap);
  }

  private addPlaato2ToTap(tapId: string, plaatoId: string) {
    const updateTap: Partial<ITap> = {
      kegtronId: '',
      customKegMonId: '',
      plaatoId: '',
      plaato2Id: plaatoId,
    };
    this.softUpdateCurrentTap(tapId, updateTap);
  }

  private addPlaatoToTap(tapId: string, plaatoId: string, plaatoApiKey: string) {
    const updateTap: Partial<ITap> = {
      kegtronId: '',
      customKegMonId: '',
      plaato2Id: '',
      plaatoId: plaatoId,
    };
    this.softUpdateCurrentTap(tapId, updateTap);
  }

  removeKegFromTap(tapId: string) {
    const update: Partial<ITap> = {
      kegId: '',
    };
    this.softUpdateCurrentTap(tapId, update);
  }

  removePlaato2FromTap(tapId: string) {
    const update: Partial<ITap> = {
      plaato2Id: '',
    };
    this.softUpdateCurrentTap(tapId, update);
  }
  removePlaatoFromTap(tapId: string) {
    const update: Partial<ITap> = {
      plaatoId: '',
    };
    this.softUpdateCurrentTap(tapId, update);
  }

  removeCustomKegMonFromTap(tapId: string) {
    const update: Partial<ITap> = {
      customKegMonId: '',
    };
    this.softUpdateCurrentTap(tapId, update);
  }

  removeKegtronFromTap(tapId: string) {
    const update: Partial<ITap> = {
      kegtronId: '',
    };
    this.softUpdateCurrentTap(tapId, update);
  }




  // #region FORM to ITEM
  private patchFormFromItem(item: ITap) {
    this.form.patchValue({
      name: item.name,
      dispTemp: item.dispTemp,
    });
  }


}
